module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "id": "part1"
    }
  }, [_c('span', [_c('b', {
    staticClass: "sans_normal"
  }, [_vm._v("I’m fading.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('b', {
    staticClass: "sans_normal"
  }, [_vm._v("You always knew this would happen again.")])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('b', {
    staticClass: "sans_normal"
  }, [_vm._v("Are you prepared?")])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('span', [_c('b', {
    staticClass: "sans_normal"
  }, [_vm._v("For what?")])])]), _vm._v(" "), _c('p', {
    staticClass: "ind",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('b', {
    staticClass: "sans_normal"
  }, [_vm._v("For return.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66e448cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/6part1.vue
// module id = 69
// module chunks = 0